<template>
    <div>


    </div>
</template>
<script>
export default {
    mounted(){
        let destino = this.$route.params.destino.replace('@', '')
        this.$router.push({name: destino})
    }
}
</script>